const tile = "_35st16e3rso";

export { tile };
import "./atom.tile.style.linaria.module.css";
//# sourceMappingURL=atom.tile.style.js.map
